var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"myCanvas",staticClass:"canvas-box",staticStyle:{"width":"100%","height":"100%","display":"flex","justify-content":"center","align-items":"center"}})}
var staticRenderFns = []

export { render, staticRenderFns }